import { CrossIcon } from '../../../../../../assets/icons';
import { DOCUMENT_TYPES, getDocumentLabel, getDocumentCountLabel } from './documentTypes';

/**
 * Header du modal de validation avec type de document et bouton fermer
 * @param {object} props
 * @param {string} props.adminType - Le type de document
 * @param {object} props.tempWorker - Les données du tempWorker
 * @param {number} props.docsCount - Le nombre de documents
 * @param {function} props.onClose - Callback de fermeture
 */
const ModalHeader = ({ adminType, tempWorker, docsCount, onClose }) => {
  const documentConfig = DOCUMENT_TYPES[adminType];
  
  return (
    <div className="w-full">
      {/* Bouton fermer */}
      <div className="flex justify-end mb-2">
        <div className="cursor-pointer p-1 hover:bg-gray-100 rounded transition-colors" onClick={onClose}>
          <CrossIcon wh={20} color="#374151" />
        </div>
      </div>
      
      {/* Info document */}
      <div className="p-3 border rounded flex gap-3">
        <div className="my-auto">
          {documentConfig?.icon()}
        </div>
        <div className="my-auto ft-sm">
          <div className="font-medium">{getDocumentLabel(adminType, tempWorker)}</div>
          <div className="text-gray-500">
            {getDocumentCountLabel(docsCount)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalHeader;
